import SkyNetTable from 'app/shared-components/SkyNetTable'
import SkyNetDomain, {
    SidebarTab, getUrlsFromTableConfig,
} from 'app/shared-components/SkyNetDomain'
import {
    TableControlTypes,
} from 'app/shared-components/TableControls'
import useTabsByPermission from 'app/hooks/useTabsByPermission/useTabsByPermission'

import useHasPermission from 'app/hooks/useHasPermission'
import useGatewaysRoutes from 'app/SkyNetRoutes/hooks/useGatewayRoutes'
import GatewayRequests from 'app/requests/Gateway/Gateway.requests'
import Overview from './Overview'
import GatewayCreate from './GatewayCreate'
import GatewayUpdate from './GatewayUpdate'
import GatewayChangeHistory from './GatewayChangeHistory'
import tableConfig from './Gateway.config'
import WorkSchedule from './WorkSchedule'

const tableControls: TableControlTypes[] = [
    TableControlTypes.ClearFilters,
    TableControlTypes.ClearSorting,
]

const Gateways = () => {
    const {
        Gateways: GatewayRoutes,
    } = useGatewaysRoutes()
    const gatewayCreate = useHasPermission(['gateway_create'])
    const gatewayUpdate = useHasPermission(['gateway_update'])

    const tabs: SidebarTab[] = useTabsByPermission([
        {
            tab: {
                url: GatewayRoutes.Overview.route,
                label: 'Overview',
                Component: Overview,
            },
            permission: true,
        },
        {
            tab: {
                url: GatewayRoutes.Update.route,
                label: 'Data Update',
                Component: GatewayUpdate,
            },
            permission: gatewayUpdate,
        },
        {
            tab: {
                url: GatewayRoutes.WorkSchedule.route,
                label: 'Work Schedule',
                Component: WorkSchedule,
            },
            permission: gatewayUpdate,
        },
        {
            tab: {
                label: 'Change History',
                url: GatewayRoutes.ChangeHistory.route,
                Component: GatewayChangeHistory,
            },
            permission: true,
        },
    ])

    return (
        <SkyNetDomain
            actionComponents={{
                Create: gatewayCreate ? GatewayCreate : undefined,
            }}
            name="GatewayView"
            sidebarTabs={tabs}
            subdomainUrls={getUrlsFromTableConfig(tableConfig)}
        >
            <SkyNetTable
                moduleName={GatewayRequests.domainName}
                tableControls={tableControls}
                tableConfig={tableConfig}
                showSearch
            />
        </SkyNetDomain>

    )
}

export default Gateways
